import { render } from "./ReleaseSummary.vue?vue&type=template&id=6ea32b3e&ts=true"
import script from "./ReleaseSummary.vue?vue&type=script&lang=ts"
export * from "./ReleaseSummary.vue?vue&type=script&lang=ts"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__